function getHeader(countryID, lang) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    var navOwner = countryID;
    var langCode = lang;
    var URL = window.location.href;
    var domain = "";
    if (URL.includes("localhost") || URL.includes("dev")) {
        domain = "dev.us.parker.corp";
    } else if (URL.includes("test")) {
        domain = "test.parker.com";
    } else if (URL.includes("preview")) {
        domain = "stage.parker.com";
    } else {
        domain = ".parker.com";
    }
    /* eslint-disable-next-line */
    var url = 'https:\/\/hfglobal' + domain + '/header.js?divisionId=' + navOwner + '&langCode=' + langCode; 
    script.async = true;
    script.src = url;
    var header = document.getElementById('header');
    header.innerHTML = "";
    header.appendChild(script);
    script.onload = () => {
        var cookies = document.cookie.split(';');
        var strenv = '';
        if (URL.includes("dev") || URL.includes("test") || URL.includes("preview") || URL.includes("localhost"))
            strenv = 'test_';
        else
            strenv = 'prod_';
        document.getElementById("signInSection").setAttribute("style", "display: block !important");
        document.getElementById("userNameSection").setAttribute("style", "display: none !important");
        for (var i = 1; i <= cookies.length - 1; i++) {
            if (cookies[i].includes(strenv + 'login_flag') && cookies[i].split('=').length > 1) {
                document.getElementById("signInSection").setAttribute("style", "display: none !important");
                document.getElementById("userNameSection").setAttribute("style", "display: block !important");
            }
        }
    }
    window.eval('function overrideLanguageChange(){ return false; }');
    return script;
}

const getFooter = (countryID, lang) => {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    var navOwner = countryID;
    var langCode = lang;
    var URL = window.location.href;
    var domain = "";
    if (URL.includes("localhost") || URL.includes("dev")) {
        domain = "dev.us.parker.corp";
    } else if (URL.includes("test")) {
        domain = "test.parker.com";
    } else if (URL.includes("preview")) {
        domain = "stage.parker.com";
    } else {
        domain = ".parker.com";
    }
    /* eslint-disable-next-line */
    var url = 'https:\/\/hfglobal' + domain + '/footer.js?divisionId=' + navOwner + '&langCode=' + langCode;
    script.async = true;
    script.src = url;
    var footer = document.getElementById('footer');
    footer.innerHTML = "";
    footer.appendChild(script);
}

export { getHeader, getFooter }